import { render, staticRenderFns } from "./DatosPersonal.vue?vue&type=template&id=4bd99260&scoped=true"
import script from "./DatosPersonal.vue?vue&type=script&lang=js"
export * from "./DatosPersonal.vue?vue&type=script&lang=js"
import style0 from "./DatosPersonal.vue?vue&type=style&index=0&id=4bd99260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd99260",
  null
  
)

export default component.exports